module.exports = __webpack_public_path__ + "img/google_play.6cfc54bd.png";